<!-- 
HACCP情報を表示するパネル
@props
  json : 表示するHACCP情報
  schema : HACCP情報の変換パーサ（logic/parserのいずれか）
-->

<template>
  <v-card
    max-width="350"
    min-width="350"
    class="ma-2 pb-4 pt-3 relative"
    elevation="4"
  >
    <v-btn
      icon
      outlined
      color="primary"
      class="icon"
      v-if="editable"
      @click="menuOn"
    >
      <v-icon> mdi-wrench</v-icon>
    </v-btn>
    <v-card-text
      v-for="item in items"
      :key="item.key"
      style="padding-bottom: 0px; padding-top: 8px"
    >
      <div class="custom-card-title">{{ item.title }}</div>
      <div class="custom-card-text" v-html="item.message"></div>
    </v-card-text>
    <select-menu
      ref="select_menu_dlg"
      :jsonBody="json.body"
      :recordId="json.record_id"
      @pushMessage="$listeners['pushMessage']"
    ></select-menu>
  </v-card>
</template>

<script>
import ParserBase from "../../logic/parser/parser-base";
import SelectMenu from "./select-menu.vue";

export default {
  methods: {
    /**
     * メニュー画面を呼び出す
     */
    menuOn() {
      this.$refs.select_menu_dlg.showMenu();
    },
  },
  components: {
    "select-menu": SelectMenu,
  },
  props: {
    json: [Object, Array],
    schema: ParserBase,
  },
  computed: {
    items() {
      return this.schema.toContents(this.json);
    },
  },
  data() {
    return {
      editable: this.$store.getters.userId == this.$route.params.uid,
    };
  },
};
</script>

<style scoped>
.relative {
  position: relative;
}
.icon {
  position: absolute;
  top: 10;
  left: 80%;
}
.custom-card-title {
  font-size: 24px;
  color: #333;
  line-height: 1.3;
}
.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
  padding-left: 16px;
}
</style>
